import React from "react";
import { FirmwareRelease } from "@/api/firmware";
import { Time } from "@/components/common/Time";
import { PublishToggle } from "./PublishToggle";

export function ReleaseTable({ releases }: { releases: FirmwareRelease[] }) {
  if (releases.length === 0) {
    return <p className="text-textLight text-sm">No firmware releases yet.</p>;
  }
  return (
    <div className="rounded-md border border-border overflow-hidden bg-surface">
      <table className="w-full text-sm">
        <thead className="bg-bg text-textLight text-xs uppercase">
          <tr>
            <th className="text-left px-md py-sm">Version</th>
            <th className="text-left px-md py-sm">Model</th>
            <th className="text-left px-md py-sm">Released</th>
            <th className="text-left px-md py-sm">SHA256</th>
            <th className="text-left px-md py-sm">Notes</th>
            <th className="text-left px-md py-sm">State</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-border">
          {releases.map(r => (
            <tr key={r.id} className="hover:bg-bg align-top">
              <td className="px-md py-sm font-medium">{r.version}</td>
              <td className="px-md py-sm">{r.applies_to_model}</td>
              <td className="px-md py-sm"><Time iso={r.released_at} /></td>
              <td className="px-md py-sm font-mono text-xs text-textLight truncate max-w-[12ch]">
                {r.sha256 ?? "—"}
              </td>
              <td className="px-md py-sm text-textLight text-xs max-w-[24ch]">
                {r.release_notes ?? "—"}
              </td>
              <td className="px-md py-sm">
                <PublishToggle releaseId={r.id} isPublished={r.is_published} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
